import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import styled from "styled-components";
const AppLinks = () => {
  return (
    <Wrapper>
      <a href="#">
        <StaticImage
          className="mr-3 app-link-img"
          src="../../assets/images/play-store.png"
          alt="play"
        />
      </a>
      <a href="#">
        <StaticImage
          className="mr-3 app-link-img"
          src="../../assets/images/app-store.png"
          alt="app"
        />
      </a>
    </Wrapper>
  );
};

export default AppLinks;
const Wrapper = styled.div`
  height: 40px;

  .app-link-img {
    width: 150px;
    height: 40px;
    object-fit: fit;
    border-radius: 4px;
    margin-bottom: 1rem;
  }
`;
